<template>
  <div>
    <van-field v-model="selectValue" :placeholder="placeholder" type="text" :label="label" :is-link="isLink"
      :readonly="readonly" @focus="onFocus" />
    <div class="van-hairline--bottom"></div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" name="abc" :title="title" />
  </div>
</template>

<script>
  export default {
    name: "SingleSelect",
    props: {
      label: {
        type: String,
        default: "未定义",
      },
      placeholder: {
        type: String,
        default: "请选择",
      },
      title: {
        type: String,
        default: "请选择",
      },
      dictid: {},
      value: {
        default: "",
      },
      selectkey: {
        default: "",
      },
    },
    data() {
      return {
        form: {
          token: "",
        },
        selectValue: this.value,
        isLink: true,
        readonly: true,
        show: false,
        actions: [],
        token: "",
        companyid: "",
        clickItemFlag: false
      };
    },
    watch: {
      value(newVal) {
        this.selectValue = newVal;
      },
      selectkey(newVal) {
        let that = this
        let filterList = that.actions.filter(m => m.id == newVal)
        if (filterList.length > 0) {
          that.selectValue = filterList[0].name
        }
      }

    },
    methods: {
      onFocus: function() {
        this.show = true;
      },
      onSelect: function(item) {
        // 默认情况下点击选项时不会自动收起
        // 可以通过 close-on-click-action 属性开启自动收起

        this.clickItemFlag = true
        this.show = false;
        this.selectValue = item.name;
        this.$emit("input", this.selectValue);
        this.$emit("update:selectkey", item.id);
      },
      LoadDictItem: function() {
        let args = {
          currentPage: 1,
          dictid: this.dictid,
          pageSize: 9999,
        };
        var that = this;
        this.$utils.HttpPost(
          this.$utils.Url.system + "/api/APISEMP_DictItem/List",
          args,
          function(data) {
            for (var i = 0; i < data.Data.length; i++) {
              let arg = {
                name: data.Data[i]["DictItemName"],
                id: data.Data[i]["id"],
              };
              that.actions.push(arg);
            }

            let filterList = that.actions.filter(m => m.id == that.selectkey)
            if (filterList.length > 0) {
              that.selectValue = filterList[0].name
            }

          },
          null,
          null
        );
      },
    },
    mounted: function() {
      this.token = sessionStorage.getItem("token");
      this.LoadDictItem();
    },
  };
</script>

<style>
</style>
